import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 71959 95944"
    {...props}
  >
    <path
      d="M36617 57592H19111v26711c0 3821-901 6699-2702 8675-1802 1978-4086 2966-6810 2966-2877 0-5205-966-6963-2921C879 91068 0 88190 0 84435V11707c0-4195 967-7204 2900-9005S7887 0 12103 0h24514c7248 0 12827 549 16737 1669 3867 1076 7204 2856 10017 5339 2811 2504 4942 5534 6390 9137 1473 3601 2198 7666 2198 12168 0 9620-2966 16892-8874 21856-5930 4942-14739 7423-26468 7423zm-4636-43227H19111v28862h12870c4504 0 8282-483 11314-1427 3008-945 5315-2483 6918-4635 1582-2130 2372-4964 2372-8435 0-4173-1230-7555-3668-10170-2745-2789-8391-4195-16936-4195z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
